<form [formGroup]="form" (submit)="onSubmitForm()">
  <div class="block block-rounded block-themed">
    <div class="block-header bg-gd-primary">
      <h3 class="block-title">Email Preferences</h3>
      <div class="block-options">
        <button type="submit" class="btn btn-sm btn-alt-primary" (click)="onSubmitForm()" [disabled]="housing == null || isLoading === true">
          <i class="fa fa-save mr-5" *ngIf="isLoading === false"></i>
          <i class="fa fa-cog fa-spin mr-5" *ngIf="isLoading === true"></i>Save
        </button>
      </div>
    </div>
    <div class="block-content block-content-full">

      <div class="form-group row">
        <div class="col-6">
          Contract Reminder After Booking
        </div>
        <div class="col-4 offset-2">
          <label class="css-control css-control-success css-switch">
            <input type="checkbox" class="css-control-input" id="contractReminderAfterBooking" name="contractReminderAfterBooking"
                   formControlName="contractReminderAfterBooking">
            <span class="css-control-indicator"></span>
          </label>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-6">
          Housing Request Reminder
        </div>
        <div class="col-4 offset-2">
          <label class="css-control css-control-success css-switch">
            <input type="checkbox" class="css-control-input" id="housingRequestReminder" name="housingRequestReminder"
                   formControlName="housingRequestReminder">
            <span class="css-control-indicator"></span>
          </label>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-6">
          Departure Billing Notification
        </div>
        <div class="col-4 offset-2">
          <label class="css-control css-control-success css-switch">
            <input type="checkbox" class="css-control-input" id="sendDepartureBillingNotification" name="sendDepartureBillingNotification"
                   formControlName="sendDepartureBillingNotification">
            <span class="css-control-indicator"></span>
          </label>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-6">
          Recommended Actions Notification
        </div>
        <div class="col-4 offset-2">
          <label class="css-control css-control-success css-switch">
            <input type="checkbox" class="css-control-input" id="recommendedActions" name="recommendedActions"
                   formControlName="recommendedActions">
            <span class="css-control-indicator"></span>
          </label>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-6">
          Booking Confirmation Reminder
        </div>
        <div class="col-4 offset-2">
          <label class="css-control css-control-success css-switch">
            <input type="checkbox" class="css-control-input" id="bookingConfirmationReminder" name="bookingConfirmationReminder"
                   formControlName="bookingConfirmationReminder">
            <span class="css-control-indicator"></span>
          </label>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-6">
          Missing AGB Notification
        </div>
        <div class="col-4 offset-2">
          <label class="css-control css-control-success css-switch">
            <input type="checkbox" class="css-control-input" id="sendPaymentMissingAgbsNotification" name="sendPaymentMissingAgbsNotification"
                   formControlName="sendPaymentMissingAgbsNotification">
            <span class="css-control-indicator"></span>
          </label>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-6">
          Monthly Performance Update
        </div>
        <div class="col-4 offset-2">
          <label class="css-control css-control-success css-switch">
            <input type="checkbox" class="css-control-input" id="monthlyPerformanceUpdate" name="monthlyPerformanceUpdate"
                   formControlName="monthlyPerformanceUpdate">
            <span class="css-control-indicator"></span>
          </label>
        </div>
      </div>

    </div>
  </div>
</form>
